import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Cookie-first session. In-memory Bearer fallback for cross-device/API clients
// (kept out of localStorage to reduce XSS blast radius).
let _memToken = null;

function readCsrf() {
  try {
    const m = document.cookie.match(/(?:^|;\s*)hb_csrf=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  } catch (err) {
    console.warn("Could not read CSRF cookie:", err);
    return null;
  }
}

const client = axios.create({ baseURL: API, withCredentials: true });

client.interceptors.request.use((config) => {
  const method = (config.method || "get").toUpperCase();
  if (!["GET", "HEAD", "OPTIONS"].includes(method)) {
    const csrf = readCsrf();
    if (csrf) config.headers["X-CSRF-Token"] = csrf;
  }
  // Bearer only used if we have a memory token AND no cookie (mobile/dev fallback)
  if (_memToken && !document.cookie.includes("hb_csrf=")) {
    config.headers.Authorization = `Bearer ${_memToken}`;
  }
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (err) => Promise.reject(err),
);

export default client;

export function saveAuth(token, user) {
  _memToken = token || null;
  localStorage.setItem("hb_user", JSON.stringify(user));
}

export function clearAuth() {
  _memToken = null;
  localStorage.removeItem("hb_user");
  // Best-effort logout on backend (clears httpOnly cookie).
  try {
    client.post("/auth/logout").catch((err) => {
      console.warn("Logout call failed (safe to ignore):", err?.message || err);
    });
  } catch (err) {
    console.warn("Logout invocation error:", err);
  }
}

export function getUser() {
  try {
    return JSON.parse(localStorage.getItem("hb_user") || "null");
  } catch (err) {
    console.warn("Corrupt hb_user in localStorage, clearing:", err);
    localStorage.removeItem("hb_user");
    return null;
  }
}

export function getToken() {
  return _memToken;
}

export function isCookieAuth() {
  return typeof document !== "undefined" && /(?:^|;\s*)hb_csrf=/.test(document.cookie);
}
